<template>
  <div id="callplandetail">
    <div bg-cow></div>
    <header>
      <div hd-left> <img hd-left-img src="../../assets/imgs/home/牛2.png" /> 牛人搭档</div>
      <div hd-mid>问卷拜访明细</div>
    </header>

    <div baseInfo v-loading="loading">
      <div mtitle>拜访基本信息</div>
      <div mbody>
        <table>
          <tr>
            <td>任务名称：<span>{{baseInfo.JobTaskName+'---'+baseInfo.Version}}</span></td>
            <td>拜访日期：<span>{{baseInfo.CallDateStr}}</span></td>
            <!-- <td>拜访人：<span>{{baseInfo.UserName}}</span></td> -->
            <td>岗位名称：<span>{{baseInfo.WorkRoleName}}</span></td>
            <td></td>
          </tr>
          <tr>
            <td>门店名称：<span>{{baseInfo.CustomerName}}</span></td>
            <td>门店编码：<span>{{baseInfo.CustomerCode}}</span></td>
            <td>门店渠道：<span>{{baseInfo.ChannelName}}</span></td>
            <td>进出店偏差：<span>{{baseInfo.OffsetDistance}} 米</span></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="4">门店地址：<span>{{baseInfo.CustomerAddress}}</span></td>
          </tr>
        </table>

        <div visit-area>
          <table visit-area-table>
            <tr>
              <td>
                <span visit-area-table-title>进店信息</span>
                <span visit-area-table-subt><i>进店时间：</i>{{baseInfo.CallStart || '-'}}</span>
                <span
                  visit-area-table-subt><i>进店GPS：</i>{{(baseInfo.StartLongitude||'-')+','+(baseInfo.StartLatitude||'-')}}</span>
              </td>
              <td visit-area-border>
                <span visit-area-table-title>出店信息</span>
                <span visit-area-table-subt><i>出店时间：</i>{{baseInfo.CallEnd || '-'}}</span>
                <span
                  visit-area-table-subt><i>出店GPS：</i>{{(baseInfo.EndLongitude||'-')+','+(baseInfo.EndLatitude||'-')}}</span>
              </td>
              <td visit-area-border-img v-viewer>
                <img v-for="(p,index) in baseInfo.CustPhotoList" :src="p.VirtrualPath" alt="" :label="p.ItemLabel"
                  :stime="p.ShotTime" :cname="p.CustomerName" :caddr="p.Address">
              </td>
            </tr>
          </table>
        </div>


      </div>

    </div>

    <div fixed-left>
      <ul>
        <li v-for="m in baseInfo.Templates " :class="{'active': m.active&&m.active==true}"
          @click="getCallCardModuleByTid(m)">{{m.Name}}</li>
      </ul>
    </div>

    <!-- <div baseInfo v-loading="loading">
      <div mtitle>未选择照片</div>
      <div bbody>
        <img v-for="(p,index) in baseInfo.NotSelPhotos" :src="p" alt=""
          style="width:80px;height:50px; object-fit:cover;margin-right: 10px;vertical-align: middle; cursor: pointer;    margin-bottom: 8px;"
          :preview="1">
      </div>
    </div> -->

    <div id="pic-detail-info" pic-detail-info hidden>
      <div id="i_label"></div>
      <div id="i_stime"></div>
      <div id="i_cname"></div>
      <div id="i_caddr"></div>
    </div>

    <div baseInfo v-loading="dloading" v-viewer>
      <div mtitle>拜访详细信息
        <el-button type="primary" size="mini" :loading="downLoading" @click="downloadImgs()" icon="el-icon-search"
          style="float: right;">下载照片</el-button>
      </div>
      <div bbody v-for="m in baseInfo.Templates">
        <div bbody-block :id="'m_'+m.TemplateId">{{m.Name}}</div>
        <callcarddetailitem :list="m.Items" :groups="m.Children"></callcarddetailitem>
      </div>
    </div>

  </div>
</template>
<script>
  import { GetCallCardBase, imgServerHost, GetCallCardModule, GetCallCardDetailPhotoRar, getBaseUrl } from "../../api/api";
  import libs from "../../utils/libs";
  import store from "../../utils/storage";
  import moment from "moment";
  import linq from "linq";
  import Vue from 'vue'
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  Vue.use(Viewer, {
    defaultOptions: {
      ready: () => {
        console.info('Viewer', Viewer);
      },
      hide: () => {
        var wrap = document.getElementById('pic-detail-info');
        wrap.setAttribute("hidden", true);
      },
      view: (index) => {
        console.info('viewO-', index);
        console.info('viewO-target', index.target);
        console.info('viewO-target-img', index.target.querySelectorAll('img'));

        var children = index.target.querySelectorAll('img');
        var curPic = children[index.detail.index];
        console.info(curPic);
        var wrap = document.getElementById('pic-detail-info');
        wrap.removeAttribute("hidden");

        var i_label = document.getElementById('i_label');
        var i_label = document.getElementById('i_label');
        var i_stime = document.getElementById('i_stime');
        var i_cname = document.getElementById('i_cname');
        var i_caddr = document.getElementById('i_caddr');
        i_label.innerText = curPic.attributes['label'].nodeValue;
        i_stime.innerText = curPic.attributes['stime'].nodeValue;
        i_cname.innerText = curPic.attributes['cname'].nodeValue;
        i_caddr.innerText = curPic.attributes['caddr'].nodeValue;

      },
    }
  });
  import callcarddetailitem from "../customComponents/call-card-detail-item/call-card-detail-item.vue";

  export default {
    components: { callcarddetailitem },
    data() {
      return {
        hostUrl: getBaseUrl(),
        loading: false,
        dloading: false,
        downLoading: false,
        callCardId: this.$route.params.callId,
        baseInfo: {},
        moduleInfo: {},
        picDetailInfo: {},
      };
    },
    mounted() {
      this.getCallCardBase();
    },

    methods: {
      getCallCardBase() {
        this.loading = true;
        GetCallCardBase(this.callCardId).then(res => {
          if (res.data.Code != 1) {
            this.$alert("加载失败：" + res.data.Msg, "提示", {
              confirmButtonText: "确定",
              type: "error"
            }).then(() => { });
            return;
          }
          this.baseInfo = res.data.Data;
          var t1 = linq.from(this.baseInfo.Templates).first();
          t1.active = true;

          this.baseInfo.Templates.forEach(element => {
            this.getCallCardModuleNew(element);
          });

          // this.getCallCardModule(t1.TaskId, t1.TemplateId);
          this.loading = false;
        });
      },

      getCallCardModuleNew(element) {
        this.dloading = true;
        var param = { taskId: element.TaskId, templateId: element.TemplateId, callCardId: this.callCardId };
        GetCallCardModule(param).then(res => {
          if (res.data.Code != 1) return;
          element.Items = res.data.Data.Items;
          element.Children = res.data.Data.Children;
          // this.moduleInfo = res.data.Data;
          this.dloading = false;
        });
      },

      getCallCardModule(taskId, templateId, itemType) {
        this.dloading = true;
        var param = { taskId: taskId, templateId: templateId, callCardId: this.callCardId, itemType: itemType };
        GetCallCardModule(param).then(res => {
          if (res.data.Code != 1) return;
          this.moduleInfo = res.data.Data;
          this.dloading = false;
          this.$previewRefresh();
        });
      },

      getCallCardModuleByTid(module) {
        this.baseInfo.Templates.forEach(e => e.active = false);
        module.active = true;
        var e = document.querySelector('#m_' + module.TemplateId);
        e.scrollIntoView();
        this.$forceUpdate();
      },

      downloadImgs() {
        this.downLoading = true;

        GetCallCardDetailPhotoRar(this.callCardId).then(res => {
          this.downLoading = false;
          if (res.data.Code != 1) return;
          var fileUrl = this.hostUrl + '/' + res.data.Data;
          window.open(fileUrl, "_blank");
        });

      },

    }
  };
</script>

<style scoped>
  @import "../../assets/css/callPlan/callplandetail.css";
</style>


// WEBPACK FOOTER //
// src/components/callPlan/CallCardDetail.vue